import React from 'react';
import { ButtonProps as MUIButtonProps } from '@mui/material';
import { LoadingButton } from '@mui/lab';

export interface ButtonProps extends MUIButtonProps {
  style?: React.CSSProperties;
  size?: MUIButtonProps['size'];
  color?: MUIButtonProps['color'];
  disabled?: MUIButtonProps['disabled'];
  fullWidth?: MUIButtonProps['fullWidth'];
  startIcon?: MUIButtonProps['startIcon'];
  variant?: MUIButtonProps['variant'];
  loading?: boolean;
  uppercase?: boolean;
  children?: React.ReactNode;
  textColor?: string;
  href?: string;
  to?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  ref?: React.Ref<HTMLButtonElement>;
}

export const Button = ({
  variant = 'contained',
  type = 'submit',
  ref,
  ...props
}: ButtonProps) => {
  return <LoadingButton type={type} variant={variant} {...props} ref={ref} />;
};
